import { I18n } from "i18n-js";
import { en, es, ja, de } from "../../config/localizations";

const i18n = new I18n({ en, es, ja, de });

export function useI18N() {
  i18n.enableFallback = true;
  i18n.defaultLocale = "en";
  // i18n.defaultLocale = "de";
  return i18n;
}
